<template>
  <div class="product-review-mini" :class="{ 'product-review-mini--has-link': scrollTo }">
    <div
      v-if="scrollTo"
      class="product-review-mini__overlay"
      role="button"
      tabindex="0"
      :aria-label="ariaLabel"
      @click="handleScrollTo"
      @keydown.enter="handleScrollTo"></div>
    <!-- TrustBox widget - Product Mini -->
    <div
      :id="id"
      class="trustpilot-widget"
      :data-locale="clientModel.trustPilotSettings.trustPilotLocale"
      :data-review-languages="clientModel.trustPilotSettings.trustPilotDataReviewLanguage"
      data-template-id="54d39695764ea907c0f34825"
      :data-businessunit-id="clientModel.trustPilotSettings.trustPilotBUnitId"
      data-style-height="24px"
      data-style-width="100%"
      :data-sku="sku"
      data-no-reviews="collapse"
      data-scroll-to-list="false"
      :data-style-alignment="alignment">
      <a :href="clientModel.trustPilotSettings.trustPilotFallbackLink" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    sku: {
      type: String,
      required: true
    },
    alignment: {
      type: String,
      default: 'center'
    },
    scrollTo: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: 'Se recensioner'
    }
  },
  data: () => ({
    id: ''
  }),
  async mounted() {
    this.id = _.uniqueId('product-review-mini-')
    await this.$nextTick()
    if (window.Trustpilot) {
      const widget = document.getElementById(this.id)
      window.Trustpilot.loadFromElement(widget)
    }
  },
  methods: {
    handleScrollTo() {
      const targetId = this.scrollTo.replace('#', '')
      const contentEl = document.getElementById(targetId)
      if (!contentEl) return

      // Find the tab trigger that controls this content panel and activate it
      // This resets all other tabs via the tabs directive's tabCallback
      const tabTrigger = document.querySelector(`.js-tab-trigger[aria-controls="${targetId}"]`)
      if (tabTrigger && tabTrigger.getAttribute('aria-expanded') !== 'true') {
        tabTrigger.click()
      }

      // Find the accordion toggler inside the tab content and expand it if collapsed
      const accordionToggler = document.querySelector(`.js-accordion-toggler[aria-controls="${targetId}"]`)
      if (accordionToggler && accordionToggler.getAttribute('aria-expanded') !== 'true') {
        accordionToggler.click()
      }

      // Scroll after a short delay to allow the tab/accordion to open
      setTimeout(() => {
        const headerEl = document.querySelector('.header-top, .header, [class*="header"]')
        const offset = headerEl ? headerEl.getBoundingClientRect().height : 80
        const top = contentEl.getBoundingClientRect().top + window.scrollY - offset - 16
        window.scrollTo({ top, behavior: 'smooth' })
      }, 50)
    }
  }
}
</script>

<style scoped>
.product-review-mini--has-link {
  position: relative;
  cursor: pointer;
}

.product-review-mini__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  cursor: pointer;
}
</style>
